import { Component, HostListener, OnDestroy } from '@angular/core';
import { catchError, filter, interval, map, merge, mergeMap, Subscription, takeWhile, tap, timer } from 'rxjs';
import { MsAuthService } from 'src/app/services/ms-auth.service';
import { MsGraphService } from 'src/app/services/ms-graph.service';
import { EFixedVerbs, IOutboundEventRequest, IOutboundMessage, QueryEventsService } from 'src/app/services/query-events.service';
import { environment } from 'src/environments/environment';
import { ProgressBarMode, MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-cti-widget',
  standalone: true,

  templateUrl: './cti-widget.component.html',
  styleUrl: './cti-widget.component.scss',
  imports: [MatProgressBarModule, MatProgressSpinnerModule],
})
export class CtiWidgetComponent implements OnDestroy {
  public employeeId: string;
  private _timerSubscription: Subscription;
  public errorMessage: Error | null;
  public progressValue: number;
  public progressBuffer: number;
  public progressBarMode: ProgressBarMode = "buffer";
  public isFetching: boolean = false;
  constructor(
    private authService: MsAuthService,
    private graphService: MsGraphService,
    private qeService: QueryEventsService,
  ) {
    this.authService.resolveToken$.subscribe(token => {
      if (token) {
        if (!this.employeeId) {
          this.graphService.getEmployeeId().subscribe(result => {
            if (result?.employeeId) {
              this.employeeId = result?.employeeId;
              if (!this._timerSubscription) {
                this._fetchQueryEvents();
              }
            } else {
              console.log("Failed fetching employee ID");
            }
          })
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this._timerSubscription) this._timerSubscription.unsubscribe();
  }

  private _fetchQueryEvents(seconds?: number) {
    if (this._timerSubscription) this._timerSubscription.unsubscribe();
    const secondsToFetch = seconds ?? 10;
    this._timerSubscription = timer(0, 1000 * secondsToFetch).pipe(
      filter(() => !this.isFetching),
      mergeMap(_ => {
        this.isFetching = true;
        return this.qeService.processQueryEvents(this.employeeId).pipe(
          map((acc: boolean) => {
            this.errorMessage = null;
            this.isFetching = false;
            return acc;
          }),
          catchError((e) => {
            this.isFetching = false;
            console.error(e)
            this.errorMessage = e;
            // if (e.message == EFixedVerbs.Event_Deletion_Message) {
            //   console.log('Detect events deletion failure, stop message subscription');
            //   this._timerSubscription.unsubscribe();
            // }
            return "";
          })
        );
      })
    ).subscribe();
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: IOutboundMessage) {
    console.log("On outbound post message");
    if (event.origin != environment.ctiTargetOrigin) {
      console.log('CTI Widget Error: mismatched outbound message origin');
      return;
    }
    if (!this.employeeId) {
      console.log('CTI Widget Error: missing employee Id');
      return;
    }
    this._onProcessingOutboundMessages(event);
  }

  private _onProcessingOutboundMessages(event: IOutboundMessage) {
    console.log("On outbound API call");
    const outboundRequest = {
      EmployeeID: this.employeeId,
      ActivityID: event.data.ActivityUUID,
      PhoneNumber: event.data.PhoneNumber
    } as IOutboundEventRequest;
    this.qeService.outboundEvents(outboundRequest).subscribe({
      next: (result) => {
        console.log("Done posting outbound message to twilio");
      },
      error: (e) => {
        console.error(e);
      }
    })

  }
}
